import { AnchorHTMLAttributes, FC, KeyboardEvent, ReactNode, Ref } from 'react';

import { Link, LinkProps } from '@purpur/library';

import { KeyboardCode } from '@telialt/common-constants/src/keyboard-codes';
import { KeyboardKey } from '@telialt/common-constants/src/keyboard-keys';

type AnchorProps = AnchorHTMLAttributes<HTMLAnchorElement>;
type Inherited = Omit<AnchorProps, 'role' | 'onKeyDown' | 'href' | 'tabIndex'> & Pick<LinkProps, 'negative'>;
type Props = {
    children?: ReactNode;
    dataTest?: string;
    ref?: Ref<HTMLAnchorElement>;
} & Inherited;

const handleKeyDownToReplicateClick = <El extends HTMLElement>(event: KeyboardEvent<El>) => {
    if (event.key === KeyboardKey.Enter || event.code === KeyboardCode.Space) {
        event.preventDefault();
        event.currentTarget.click();
    }
};

export const TextButton: FC<Props> = ({ children, className, negative, hidden, onClick, dataTest, ref, ...props }) => (
    <Link variant="text" disableVisited={true} className={className} negative={negative} hidden={hidden}>
        <a
            {...props}
            onClick={onClick}
            data-test={dataTest}
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDownToReplicateClick}
            ref={ref}
        >
            {children}
        </a>
    </Link>
);
